import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  BasicDataActionTypes,
  getBasicDataFailure,
  getBasicDataSuccess,
  getCurrencies,
  getIndustries,
  getSegments,
  updateBasicDataFailure,
  updateBasicDataSuccess,
} from '../actions';
import { catchError, map, mergeMap, of, switchMap } from 'rxjs';
import { BasicDataService } from '../../services';
import { SnackbarService } from '@shared';
import { IBasicData, IField } from '@shared/model/basic-data';
import { Store } from '@ngrx/store';
import { IRootState } from '@app/store';
import { ErrorsService } from '@app/errors/errors.service';
import { getProjectInfo } from '@app/project/store';

@Injectable()
export class BasicDataEffects {
  constructor(
    private _actions$: Actions,
    private _basicDataService: BasicDataService,
    private _snackbarService: SnackbarService,
    private _store: Store<IRootState>,
    private _errorsService: ErrorsService,
  ) {}

  getBasicData$ = createEffect(() =>
    this._actions$.pipe(
      ofType(BasicDataActionTypes.GET_BASIC_DATA),
      mergeMap(({ id }) =>
        this._basicDataService.getBasicData(id).pipe(
          map((basicData: IBasicData) => {
            if (basicData.industry_main !== undefined && basicData.industry_main !== null) {
              this._store.dispatch(getSegments({ industry: basicData.industry_main }));
            }
            return getBasicDataSuccess({ basicData });
          }),
          catchError((err: HttpErrorResponse) => {
            if (err.error.detail) {
              this._errorsService.openPopup(err);
            } else {
              this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            }
            return of(getBasicDataFailure());
          }),
        ),
      ),
    ),
  );

  updateBasicDate$ = createEffect(() =>
    this._actions$.pipe(
      ofType(BasicDataActionTypes.UPDATE_BASIC_DATA),
      mergeMap(({ id, data }: { id: number; data: IField }) =>
        this._basicDataService.updateBasicDataField(id, data).pipe(
          map(() => {
            if (data.name === 'industry_main') {
              this._store.dispatch(getSegments({ industry: data.value as number }));
            }
            if (data.name === 'currency_multiplication' || data.name === 'currency') {
              this._store.dispatch(getProjectInfo({ id }));
            }
            return updateBasicDataSuccess({ data });
          }),

          catchError(() => of(updateBasicDataFailure())),
        ),
      ),
    ),
  );
}
